import React, { useContext, useEffect, useState } from "react";
import { Table, Button, Input, UncontrolledTooltip } from "reactstrap";
import Select from "react-select";
import { Icon } from "../common/style";
import { ProjectButton } from "../project/style";
import {
  getPricingSummary,
  updateServiceTier,
  createPriceLineItem,
  createServicePricingItem,
  updatePriceLineItem,
  deletePriceLineItem,
  updateServicePricingItem,
  deleteServicePricingItem,
  updateDiscount,
  refreshLineItemPrices,
  clearDiscountAndRemarks,
  getMaterials,
  getServices,
  getBomSummary,
  getSignedToken,
} from "./service";
import { CoreContainer, Notification } from "../common/style";
import { AppContext } from "../context";
import LoadingSpinner from "./LoadingSpinner";
import { useParams } from "react-router-dom";
import ConfirmationModal from "../project/ConfirmationModal";
import { useOutletContext, useLocation } from "react-router-dom";
import { generateRequestUri } from "../common/service";

const PriceSummary = () => {
  const priceCellStyle = {
    textAlign: "right",
  };

  const { projectInfo: project } = useContext(AppContext);
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [currentOrder, setCurrentOrder, isAdmin] = useOutletContext();
  const { bomSummary, setBomSummary } = useContext(AppContext);
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingOn, setIsEditingOn] = useState(false);
  const [isEditingFabricationOn, setIsEditingFabricationOn] = useState(false);
  const [currentItemId, setCurrentItemId] = useState(null);
  const [currentFabricationId, setCurrentFabricationId] = useState(null);
  const [isAddingFabrication, setIsAddingFabrication] = useState(false);
  const [isAddDiscount, setIsAddDiscount] = useState(false);
  const [newDiscount, setNewDiscount] = useState(null);
  const [newDiscountRemarks, setNewDiscountRemarks] = useState(null);
  const location = useLocation();
  const [finalisedContexts, setFinalisedContexts] = useState(
    location.state?.finalisedContexts || []
  );
  const [isEditingFabrication, setIsEditingFabrication] = useState(false);
  const [updatePriceNotification, setUpdatePriceNotification] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [materialQuantity, setMaterialQuantity] = useState(null);
  const [materialPrice, setMaterialPrice] = useState(null);
  const [materialRemarks, setMaterialRemarks] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [serviceQuantity, setServiceQuantity] = useState(null);
  const [servicePrice, setServicePrice] = useState(null);
  const [serviceRemarks, setServiceRemarks] = useState(null);
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingServiceItemId, setEditingServiceItemId] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [services, setServices] = useState([]);

  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteMaterialConfirmationOpen, setDeleteMaterialConfirmationOpen] =
    useState(false);

  const toggleDeleteMaterialConfirmation = (item) => {
    setItemToDelete(item);
    setDeleteMaterialConfirmationOpen(!deleteMaterialConfirmationOpen);
  };

  const [refreshPriceconfirmationOpen, setRefreshPriceconfirmationOpen] =
    useState(false);

  const refreshPricetoggleConfirmation = () =>
    setRefreshPriceconfirmationOpen(!refreshPriceconfirmationOpen);

  const handleDeletePriceLineItem = () => {
    if (itemToDelete) {
      setIsLoading(true);
      deletePriceLineItem({
        projectId,
        orderId,
        priceLineItemId: itemToDelete.id,
      })
        .then(() => {
          setDeleteMaterialConfirmationOpen(false);
          setItemToDelete(null);
          getBOM();
        })
        .catch((error) => {
          setIsNotificationVisible(true);
          setNotification({ message: error.message, type: "error" });
        })
        .finally(() => setIsLoading(false));
    }
  };

  const [deleteServiceConfirmationOpen, setDeleteServiceConfirmationOpen] =
    useState(false);

  const [serviceToDelete, setServiceToDelete] = useState(null);

  const toggleDeleteServiceConfirmation = (service) => {
    setServiceToDelete(service);
    setDeleteServiceConfirmationOpen(!deleteServiceConfirmationOpen);
  };

  const [deleteDiscountConfirmationOpen, setDeleteDiscountConfirmationOpen] =
    useState(false);
  const toggleDeleteDiscountConfirmation = () =>
    setDeleteDiscountConfirmationOpen(!deleteDiscountConfirmationOpen);

  const projectId = params.projectId;
  const orderId = params.orderId;

  const handleQuantityChange = (e) => {
    setMaterialQuantity(e.target.value);
  };

  const handleServiceQuantityChange = (e) => {
    setServiceQuantity(e.target.value);
  };

  const handleCancelDiscountClick = () => {
    setIsAddDiscount(false);
    setNewDiscount(currentOrder.discount || "");
    setNewDiscountRemarks(currentOrder.discountRemarks || "");
  };

  const handleEdit = (item) => {
    setCurrentItemId(item.id);
    setIsEditingOn(true);
    setSelectedMaterial({
      value: item.material.id,
      label: item.material.name,
    });
    setMaterialQuantity(item.quantity);
    setMaterialPrice(item.price);
    setMaterialRemarks(item.remarks);
    setEditingItemId(item.id);
    setIsEditing(true);
    setIsAdding(false);
  };

  const handleCancelEditMaterial = () => {
    setCurrentItemId(null);
    setIsEditingOn(false);
    setSelectedMaterial(null);
    setMaterialQuantity("");
    setMaterialPrice("");
    setMaterialRemarks("");
    setEditingItemId(null);
    setIsAdding(false);
    setIsEditing(false);
  };

  const handleEditService = (item) => {
    setCurrentFabricationId(item.id);
    setIsEditingFabricationOn(true);
    setSelectedService({
      value: item.id,
      label: item.name,
    });
    setServiceQuantity(item.quantity);
    setServicePrice(item.price);
    setServiceRemarks(item.remarks);
    setEditingServiceItemId(item.id);
    setIsEditingFabrication(true);
    setIsAddingFabrication(false);
  };

  const handleCancelEditService = () => {
    setCurrentFabricationId(null);
    setIsEditingFabricationOn(false);
    setSelectedService(null);
    setServiceQuantity("");
    setServicePrice("");
    setServiceRemarks("");
    setEditingItemId(null);
    setIsEditingFabrication(false);
    setIsAddingFabrication(false);
  };

  const handleRemarksChange = (e) => {
    setMaterialRemarks(e.target.value);
  };

  const handleServiceRemarksChange = (e) => {
    setServiceRemarks(e.target.value);
  };

  const getBOM = () => {
    setIsLoading(true);

    getPricingSummary({ projectId, orderId })
      .then((response) => {
        setCurrentOrder({
          ...currentOrder,
          ...{
            summary: {
              pricing_summary: response.pricing_summary,
              is_bom_stale: response.is_bom_stale,
            },
          },
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.error, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const fetchMaterials = () => {
    setIsLoading(true);

    getMaterials({ projectId, orderId })
      .then((response) => {
        const materialOptions = response.map((material) => ({
          value: material.id,
          label: material.name,
        }));
        setMaterials(materialOptions);
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const fetchServices = () => {
    setIsLoading(true);

    getServices({ projectId, orderId })
      .then((response) => {
        const materialOptions = response.map((service) => ({
          value: service.id,
          label: service.name,
        }));
        setServices(materialOptions);
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreatePriceLineItem = () => {
    setIsLoading(true);
    createPriceLineItem({
      materialId: selectedMaterial?.value,
      newQuantity: materialQuantity,
      price: materialPrice,
      projectId,
      remarks: materialRemarks,
      orderId,
    })
      .then(() => {
        handleCancelEditMaterial();
        getBOM();
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: "Unauthorized Access", type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleCreateServicePricingItem = () => {
    setIsLoading(true);
    createServicePricingItem({
      factoryServiceId: selectedService.value,
      newQuantity: serviceQuantity,
      price: servicePrice,
      projectId,
      remarks: serviceRemarks,
      orderId,
    })
      .then(() => {
        handleCancelEditService();
        getBOM();
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleUpdatePriceLineItem = () => {
    setIsLoading(true);
    updatePriceLineItem({
      projectId,
      orderId,
      priceLineItemId: editingItemId,
      newQuantity: materialQuantity,
      price: materialPrice,
      newRemarks: materialRemarks,
    })
      .then(() => {
        handleCancelEditMaterial();
        getBOM();
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: "Unauthorized access", type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleDIscount = () => {
    setIsLoading(true);
    updateDiscount({ projectId, orderId, newDiscount, newDiscountRemarks })
      .then((orderResponse) => {
        return getPricingSummary({ projectId, orderId }).then(
          (pricingSummaryResponse) => {
            setCurrentOrder({
              ...orderResponse,
              summary: {
                pricing_summary: pricingSummaryResponse.pricing_summary,
                is_bom_stale: pricingSummaryResponse.is_bom_stale,
              },
            });
            setIsAddDiscount(false);
          }
        );
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleUpdateServicePricingItem = () => {
    setIsLoading(true);
    updateServicePricingItem({
      projectId,
      orderId,
      servicePricingItemId: editingServiceItemId,
      newQuantity: serviceQuantity,
      price: servicePrice,
      newRemarks: serviceRemarks,
    })
      .then(() => {
        handleCancelEditService();
        getBOM();
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleDeleteServicePricingItem = () => {
    if (serviceToDelete) {
      setIsLoading(true);
      deleteServicePricingItem({
        projectId,
        orderId,
        servicePricingItemId: serviceToDelete.id,
      })
        .then(() => {
          setDeleteServiceConfirmationOpen(false);
          setServiceToDelete(null);
          getBOM();
        })
        .catch((error) => {
          setIsNotificationVisible(true);
          setNotification({ message: error.message, type: "error" });
        })
        .finally(() => setIsLoading(false));
    }
  };

  const handleClearDiscountAndRemarks = () => {
    setIsLoading(true);

    clearDiscountAndRemarks({ projectId, orderId })
      .then((orderResponse) => {
        return getPricingSummary({ projectId, orderId }).then(
          (pricingSummaryResponse) => {
            setCurrentOrder({
              ...orderResponse,
              summary: {
                pricing_summary: pricingSummaryResponse.pricing_summary,
                is_bom_stale: pricingSummaryResponse.is_bom_stale,
              },
            });
            setDeleteDiscountConfirmationOpen(false);
          }
        );
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => setIsLoading(false));
  };

  const handleRefreshLineItemPrices = () => {
    setIsLoading(true);

    refreshLineItemPrices({ projectId, orderId })
      .then((orderResponse) => {
        setUpdatePriceNotification(false);
        return getPricingSummary({ projectId, orderId }).then(
          (pricingSummaryResponse) => {
            setCurrentOrder({
              ...orderResponse,
              summary: {
                pricing_summary: pricingSummaryResponse.pricing_summary,
                is_bom_stale: pricingSummaryResponse.is_bom_stale,
              },
            });
            return getBomSummary(projectId, false).then((response) => {
              setBomSummary({ ...response, loaded: true, is_outdated: false });
            });
          }
        );
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ message: error.message, type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
        setRefreshPriceconfirmationOpen(false);
      });
  };

  const forceRefreshPricing = () => {
    alert("Not available. Please contact support");
  };

  useEffect(() => {
    fetchMaterials();
  }, []);

  useEffect(() => {
    fetchServices();
  }, []);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const getOption = (option) => {
    return { name: option.name, label: option.name, value: option.id };
  };

  const handleServiceTierChange = (selectedTierId) => {
    updateServiceTier({
      projectId: projectId,
      serviceTierId: selectedTierId,
    })
      .then(() => {
        getBOM();
      })
      .catch(({ error }) => {});
  };

  const downloadBom = () => {
    setIsLoading(true);

    getSignedToken({
      projectId: params.projectId,
      resource: "bom_download",
    })
      .then(({ token }) =>
        window.open(
          generateRequestUri({
            url: `orders/${orderId}/bom_export`,
            params: { signed: token },
          }),
          "_blank",
          "noreferrer"
        )
      )
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "danger", message: error });
      })
      .finally(() => setIsLoading(false));
  };

  if (!currentOrder.summary.pricing_summary) {
    return notification.message ? (
      <Notification
        color={notification.type === "error" ? "danger" : "success"}
        isOpen={isNotificationVisible}
        toggle={onDismissNotification}
      >
        {notification.message}
      </Notification>
    ) : null;
  }

  return (
    <>
      {currentOrder.outdated && (
        <div
          className="notification"
          style={{
            backgroundColor: "#FEE7B9",
            color: "black",
            padding: "10px",
            border: "1px solid #FFE4C4",
            borderRadius: "5px",
            margin: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              className="fa-stack"
              style={{ fontSize: "8px", marginRight: "10px" }}
            >
              <i
                className="fa-regular fa-circle fa-stack-2x"
                style={{ color: "#00040a" }}
              ></i>
              <i
                className="fa-solid fa-exclamation fa-stack-1x"
                style={{ color: "#00040a" }}
              ></i>
            </span>
            <p style={{ margin: "0" }}>
              Prices of some items in this order have changed.
            </p>
          </div>
          <Button
            className="rounded-2"
            style={{
              color: "#2C92E6",
              border: "1px solid #2C92E6",
              backgroundColor: "white",
              marginLeft: "15px",
            }}
            onClick={refreshPricetoggleConfirmation}
          >
            Update Prices
          </Button>
        </div>
      )}
      <ConfirmationModal
        isOpen={refreshPriceconfirmationOpen}
        toggle={refreshPricetoggleConfirmation}
        onConfirm={handleRefreshLineItemPrices}
        message={"Are you sure you want to Update ?"}
        headingText={"Confirm"}
      />
      <ConfirmationModal
        isOpen={deleteMaterialConfirmationOpen}
        toggle={() => toggleDeleteMaterialConfirmation(null)}
        onConfirm={handleDeletePriceLineItem}
        message="Are you sure you want to delete this Material?"
        headingText="Confirm Deletion"
      />
      <ConfirmationModal
        isOpen={deleteServiceConfirmationOpen}
        toggle={() => toggleDeleteServiceConfirmation(null)}
        onConfirm={handleDeleteServicePricingItem}
        message="Are you sure you want to delete this service?"
        headingText="Confirm Deletion"
      />
      {currentOrder.summary.is_bom_stale && (
        <div className="bg-dark-subtle text-danger p-2 text-center w-100 fw-bold fs-6 top-0 z-1 d-flex mt-3">
          <div className="flex-grow-1">BOM is outdated</div>
        </div>
      )}
      {project.use_advanced_optimisation && (
        <div className="bg-dark-subtle text-danger p-2 text-center w-100 fw-bold fs-6 position-sticky top-0 z-1 d-flex mt-3">
          <div className="flex-grow-1">Using Advanced Optimization</div>
          {bomSummary.is_stale && (
            <div
              className="justify-content-end pointer text-dark"
              onClick={() => {
                forceRefreshPricing();
              }}
            >
              <span className="fa fa-arrows-rotate"></span>
              <span className="ms-2">Refresh BOM</span>
            </div>
          )}
        </div>
      )}
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      {isAdmin ? (
        isLoading ? (
          <CoreContainer>
            <LoadingSpinner />
          </CoreContainer>
        ) : (
          <div className="my-3">
            <div className="mt-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                  <h5 className="flex-grow-1 fw-bold">Materials</h5>
                  {!currentOrder.summary.pricing_summary.is_external && (
                    <span>
                      <Icon
                        onClick={() => setIsAdding(!isAdding)}
                        className="fa-solid fa-circle-plus ms-3 pointer mb-2"
                        size="1.5em"
                        style={{ color: "#999" }}
                        title="Add Material"
                      />
                    </span>
                  )}
                </div>
                <div className="d-flex column-gap-3 align-items-center">
                  <Button
                    color="primary"
                    className="fw-bold rounded-1"
                    onClick={downloadBom}
                  >
                    Download BOM
                  </Button>
                  <h6 className="ms-2 text-secondary">
                    {currentOrder.summary.pricing_summary.section_wise_totals
                      ?.materials === null
                      ? "N/A"
                      : `₹${currentOrder.summary.pricing_summary.section_wise_totals?.materials.toLocaleString(
                          "en-IN"
                        )}`}
                  </h6>
                </div>
              </div>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Type</th>
                    <th>Materials</th>
                    <th>Quantity</th>
                    <th style={{ textAlign: "right" }}>Unit Price</th>
                    <th style={{ textAlign: "right" }}>Sub Total</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className="align-middle">
                  {isLoading ? (
                    <tr>
                      <td
                        colSpan="6"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Spinner size="sm" /> Loading...
                      </td>
                    </tr>
                  ) : (
                    currentOrder.summary.pricing_summary.boms?.materials.map(
                      (price_line_item, index) => (
                        <tr key={price_line_item.id}>
                          <td
                            style={{
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {price_line_item.material.type}
                          </td>
                          <td
                            style={{
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {" "}
                            {price_line_item.material?.name || "N/A"}
                            {price_line_item.remarks && (
                              <div style={{ fontSize: "14px", color: "#999" }}>
                                {price_line_item.remarks}
                              </div>
                            )}
                          </td>
                          <td
                            style={{
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {" "}
                            {price_line_item.quantity}{" "}
                            {price_line_item.material.unit || " "}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {price_line_item.is_price_stale && (
                              <span
                                className="fa-stack"
                                style={{ fontSize: "8px", marginRight: "10px" }}
                              >
                                <i
                                  className="fa-regular fa-circle fa-stack-2x"
                                  style={{ color: "#00040a" }}
                                ></i>
                                <i
                                  className="fa-solid fa-exclamation fa-stack-1x"
                                  style={{ color: "#00040a" }}
                                ></i>
                              </span>
                            )}
                            {price_line_item.price === null
                              ? "N/A"
                              : `₹${price_line_item.price.toLocaleString(
                                  "en-IN"
                                )}`}
                          </td>
                          <td
                            style={{
                              textAlign: "right",
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {price_line_item.sub_total === null
                              ? "N/A"
                              : `₹${price_line_item.sub_total.toLocaleString(
                                  "en-IN"
                                )}`}
                          </td>
                          <td
                            style={{
                              backgroundColor: price_line_item.is_price_stale
                                ? "#FEE7B9"
                                : "inherit",
                            }}
                          >
                            {" "}
                            {isEditingOn &&
                            currentItemId === price_line_item.id ? (
                              <span className="p-2">Edit Mode</span>
                            ) : (
                              <i
                                className="fa-solid fa-pencil-alt pointer me-2 p-2"
                                onClick={() => handleEdit(price_line_item)}
                              ></i>
                            )}
                            <Icon
                              className="fa-regular fa-trash-can me-2 pointer"
                              onClick={() =>
                                toggleDeleteMaterialConfirmation(
                                  price_line_item
                                )
                              }
                            />
                          </td>
                        </tr>
                      )
                    )
                  )}
                </tbody>
              </Table>

              {isAdding || isEditing ? (
                <div className="mb-3 mt-3">
                  <div className="d-flex">
                    <Select
                      options={materials}
                      value={selectedMaterial}
                      isDisabled={isEditing}
                      onChange={(option) => setSelectedMaterial(option)}
                      placeholder="Select Material"
                      className="me-2"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: "150px",
                          height: "40px",
                        }),
                      }}
                    />
                    <Input
                      type="text"
                      placeholder="Quantity"
                      value={materialQuantity || ""}
                      onChange={handleQuantityChange}
                      className="me-2"
                      style={{ width: "150px", height: "40px" }}
                    />
                    <Input
                      type="text"
                      placeholder="Price"
                      value={materialPrice || ""}
                      onChange={(e) => setMaterialPrice(e.target.value)}
                      className="me-2"
                      style={{ width: "150px", height: "40px" }}
                    />
                    <Input
                      type="textarea"
                      placeholder="Remarks"
                      value={materialRemarks || ""}
                      onChange={handleRemarksChange}
                      className="me-2"
                      style={{ width: "150px", height: "40px" }}
                    />
                    <ProjectButton
                      color="success"
                      disabled={
                        isEditing
                          ? !(
                              selectedMaterial &&
                              materialQuantity &&
                              materialPrice
                            )
                          : !(selectedMaterial && materialQuantity)
                      }
                      onClick={
                        isEditing
                          ? handleUpdatePriceLineItem
                          : handleCreatePriceLineItem
                      }
                      className="me-2 rounded-1"
                      style={{ width: "100px", height: "40px" }}
                    >
                      {isEditing ? "Update" : "Save"}
                    </ProjectButton>
                    <Button
                      onClick={handleCancelEditMaterial}
                      className="rounded-1"
                      outline
                      style={{ width: "100px", height: "40px" }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : null}
            </div>
            {currentOrder.summary.pricing_summary.service_tiers && (
              <div className="mt-5 mb-3">
                <div className="d-flex align-items-center mb-2">
                  <div className="d-flex align-items-center flex-grow-1">
                    <h5 className="fw-bold">Fabrication</h5>
                    {!currentOrder.summary.pricing_summary.is_external && (
                      <span>
                        <Icon
                          onClick={() =>
                            setIsAddingFabrication(!isAddingFabrication)
                          }
                          className="fa-solid fa-circle-plus ms-3 pointer"
                          size="1.5em"
                          style={{ color: "#999" }}
                          title="Add Fabrication"
                        />
                      </span>
                    )}
                  </div>
                  <div className="d-flex align-items-center justify-content-end">
                    <Select
                      isDisabled={
                        finalisedContexts.includes(currentOrder.context) ||
                        !currentOrder.context ||
                        !isAdmin
                      }
                      value={
                        getOption(
                          currentOrder.summary.pricing_summary.service_tiers?.find(
                            (tier) => tier.selected
                          )
                        ) || null
                      }
                      options={currentOrder.summary.pricing_summary.service_tiers?.map(
                        (tier) => getOption(tier)
                      )}
                      onChange={(selectedTier) => {
                        handleServiceTierChange(selectedTier.value);
                      }}
                      className="me-2"
                    />
                    <h6 className="text-secondary mb-0">
                      {currentOrder.summary.pricing_summary.section_wise_totals
                        ?.services === null
                        ? "N/A"
                        : `₹${currentOrder.summary.pricing_summary.section_wise_totals?.services.toLocaleString(
                            "en-IN"
                          )}`}
                    </h6>
                  </div>
                </div>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th style={priceCellStyle}>Unit Price</th>
                      <th style={priceCellStyle}>Sub Total</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <>
                        <Spinner size="sm">Loading...</Spinner> &nbsp;
                        <span>Loading...</span>
                      </>
                    ) : (
                      currentOrder.summary.pricing_summary.boms?.services.map(
                        (service, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                backgroundColor: service.is_price_stale
                                  ? "#FEE7B9"
                                  : "inherit",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                backgroundColor: service.is_price_stale
                                  ? "#FEE7B9"
                                  : "inherit",
                              }}
                            >
                              {service.name}
                              {service.remarks && (
                                <div
                                  style={{ fontSize: "14px", color: "#999" }}
                                >
                                  {service.remarks}
                                </div>
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: service.is_price_stale
                                  ? "#FEE7B9"
                                  : "inherit",
                              }}
                            >
                              {service.quantity} {service.measuring_unit}
                              {service.measuring_unit === "hole" &&
                                service.quantity > 1 &&
                                "s"}
                            </td>
                            <td
                              style={{
                                ...priceCellStyle,
                                backgroundColor: service.is_price_stale
                                  ? "#FEE7B9"
                                  : "inherit",
                              }}
                            >
                              {service.is_price_stale && (
                                <span
                                  className="fa-stack"
                                  style={{
                                    fontSize: "8px",
                                    marginRight: "10px",
                                  }}
                                >
                                  <i
                                    className="fa-regular fa-circle fa-stack-2x"
                                    style={{ color: "#00040a" }}
                                  ></i>
                                  <i
                                    className="fa-solid fa-exclamation fa-stack-1x"
                                    style={{ color: "#00040a" }}
                                  ></i>
                                </span>
                              )}
                              ₹{service.price.toLocaleString("en-IN")} /{" "}
                              {service.measuring_unit}
                            </td>
                            <td
                              style={{
                                ...priceCellStyle,
                                backgroundColor: service.is_price_stale
                                  ? "#FEE7B9"
                                  : "inherit",
                              }}
                            >
                              {" "}
                              ₹{service.sub_total.toLocaleString("en-IN")}
                            </td>
                            <td
                              style={{
                                ...priceCellStyle,
                                backgroundColor: service.is_price_stale
                                  ? "#FEE7B9"
                                  : "inherit",
                              }}
                            >
                              {" "}
                              {isEditingFabricationOn &&
                              currentFabricationId === service.id ? (
                                <span className="p-2">Edit Mode</span>
                              ) : (
                                <i
                                  className="fa-solid fa-pencil-alt pointer me-2 p-2"
                                  onClick={() => handleEditService(service)}
                                ></i>
                              )}
                              <Icon
                                className="fa-regular fa-trash-can me-2 pointer"
                                onClick={() =>
                                  toggleDeleteServiceConfirmation(service)
                                }
                              />
                            </td>
                          </tr>
                        )
                      )
                    )}
                  </tbody>
                </Table>
                {isAddingFabrication || isEditingFabrication ? (
                  <div className="mb-3 mt-3">
                    <div className="d-flex">
                      <Select
                        options={services}
                        value={selectedService}
                        isDisabled={isEditingFabrication}
                        onChange={(option) => setSelectedService(option)}
                        placeholder="Select Service"
                        className="me-2"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            width: "150px",
                            height: "40px",
                          }),
                        }}
                      />
                      <Input
                        type="text"
                        placeholder="Quantity"
                        value={serviceQuantity || ""}
                        onChange={handleServiceQuantityChange}
                        className="me-2"
                        style={{ width: "150px", height: "40px" }}
                      />
                      <Input
                        type="text"
                        placeholder="Price"
                        value={servicePrice || ""}
                        onChange={(e) => setServicePrice(e.target.value)}
                        className="me-2"
                        style={{ width: "150px", height: "40px" }}
                      />
                      <Input
                        type="textarea"
                        placeholder="Remarks"
                        value={serviceRemarks || ""}
                        onChange={handleServiceRemarksChange}
                        className="me-2"
                        style={{ width: "150px", height: "40px" }}
                      />
                      <ProjectButton
                        color="success"
                        disabled={
                          isEditingFabrication
                            ? !(
                                selectedService &&
                                serviceQuantity &&
                                servicePrice
                              )
                            : !(selectedService && serviceQuantity)
                        }
                        onClick={
                          isEditingFabrication
                            ? handleUpdateServicePricingItem
                            : handleCreateServicePricingItem
                        }
                        className="me-2 rounded-1"
                        style={{ width: "100px", height: "40px" }}
                      >
                        {isEditingFabrication ? "Update" : "Save"}
                      </ProjectButton>
                      <Button
                        onClick={handleCancelEditService}
                        className="rounded-1"
                        outline
                        style={{ width: "100px", height: "40px" }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                ) : null}
              </div>
            )}

            <div className="d-flex-column justify-content-end align-items-center">
              {currentOrder.discount && (
                <div className="d-flex justify-content-end align-items-center m-2">
                  <h4
                    className="me-2 text-end"
                    style={{ fontSize: "15px", margin: "0" }}
                  >
                    Subtotal:
                  </h4>
                  <h4
                    className="text-end"
                    style={{ fontSize: "15px", margin: "0" }}
                  >
                    {currentOrder.summary.pricing_summary.bom_total_value
                      ? `₹${(
                          currentOrder.summary.pricing_summary.bom_total_value +
                          currentOrder.discount
                        ).toLocaleString("en-IN")}`
                      : "N/A"}
                  </h4>
                </div>
              )}
              {!currentOrder.summary.pricing_summary.is_external ? (
                <div className="d-flex-column justify-content-end align-items-center">
                  <div className="d-flex justify-content-end align-items-center m-2">
                    <h5
                      className="me-2 text-end"
                      style={{ fontSize: "15px", margin: "0" }}
                    >
                      Discount:
                    </h5>
                    {isAddDiscount ? (
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          placeholder="Enter discount"
                          value={newDiscount}
                          onChange={(e) => setNewDiscount(e.target.value)}
                          style={{ fontSize: "15px", marginRight: "5px" }}
                        />
                        <input
                          type="text"
                          placeholder="Enter remarks"
                          value={newDiscountRemarks}
                          onChange={(e) =>
                            setNewDiscountRemarks(e.target.value)
                          }
                          style={{ fontSize: "15px", marginRight: "5px" }}
                        />
                        <i
                          className="fa-solid fa-check"
                          onClick={handleDIscount}
                          style={{ cursor: "pointer", marginRight: "5px" }}
                        ></i>

                        <i
                          className="fa-solid fa-xmark"
                          onClick={handleCancelDiscountClick}
                          style={{ cursor: "pointer" }}
                        ></i>
                      </div>
                    ) : (
                      !currentOrder.discount &&
                      !currentOrder.summary.pricing_summary.is_external && (
                        <i
                          className="fa-solid fa-circle-plus ms-3 pointer mb-2"
                          onClick={() => setIsAddDiscount(!isAddDiscount)}
                          style={{ fontSize: "15px", margin: "5px" }}
                          title="Add Discount"
                        ></i>
                      )
                    )}

                    {currentOrder.discount && (
                      <div>
                        <i
                          id="remarks"
                          className="fa-solid fa-circle-info"
                          style={{ fontSize: "15px", marginRight: "5px" }}
                        ></i>
                        <UncontrolledTooltip
                          style={{
                            fontSize: "16px",
                            padding: "6px 20px",
                            background: "white",
                            color: "black",
                          }}
                          target="remarks"
                          placement="top"
                        >
                          {currentOrder.discount_remarks}
                        </UncontrolledTooltip>
                      </div>
                    )}

                    <h4
                      className="text-end"
                      style={{ fontSize: "15px", margin: "0" }}
                    >
                      {currentOrder.discount
                        ? `₹ -${currentOrder.discount}`
                        : "Not set yet"}
                    </h4>
                    <div>
                      {currentOrder.discount &&
                        !currentOrder.summary.pricing_summary.is_external && (
                          <div>
                            <i
                              className="fa-regular fa-trash-can me-2 pointer m-2"
                              onClick={toggleDeleteDiscountConfirmation}
                            ></i>
                          </div>
                        )}
                      <ConfirmationModal
                        isOpen={deleteDiscountConfirmationOpen}
                        toggle={toggleDeleteDiscountConfirmation}
                        onConfirm={handleClearDiscountAndRemarks}
                        message="Are you sure you want to delete discount?"
                        headingText="Confirm Deletion"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="d-flex-column justify-content-end align-items-center">
                  <div className="d-flex justify-content-end align-items-center m-2">
                    {currentOrder.discount && (
                      <div className="d-flex">
                        <h5
                          className="me-2 text-end"
                          style={{ fontSize: "15px", margin: "0" }}
                        >
                          Discount:
                        </h5>
                        <i
                          id="remarks"
                          className="fa-solid fa-circle-info"
                          style={{ fontSize: "15px", marginRight: "5px" }}
                        ></i>
                        <UncontrolledTooltip
                          style={{
                            fontSize: "16px",
                            padding: "6px 20px",
                            background: "white",
                            color: "black",
                          }}
                          target="remarks"
                          placement="top"
                        >
                          {currentOrder.discount_remarks}
                        </UncontrolledTooltip>
                        <h4
                          className="text-end"
                          style={{ fontSize: "15px", margin: "0" }}
                        >
                          ₹ -{currentOrder.discount}
                        </h4>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-end align-items-center m-3">
                <h5 className="me-2 m-3">Total:</h5>
                <h4 className="text-end" style={{ margin: "0" }}>
                  {currentOrder.summary.pricing_summary.bom_total_value
                    ? `₹${currentOrder.summary.pricing_summary.bom_total_value.toLocaleString(
                        "en-IN"
                      )}`
                    : "N/A"}
                </h4>
              </div>
            </div>
          </div>
        )
      ) : null}
    </>
  );
};

export default PriceSummary;
